import { render, staticRenderFns } from "./CsimConfigFormModal.vue?vue&type=template&id=4880946c&scoped=true"
import script from "./CsimConfigFormModal.vue?vue&type=script&lang=js"
export * from "./CsimConfigFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4880946c",
  null
  
)

export default component.exports